const PRODUCTION_API_URL = 'https://carbonintelligence.sustainow.in/api';

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const getConfiguredApiUrl = () => {
  const configured = process.env.REACT_APP_API_URL?.trim();
  if (!configured) {
    return null;
  }
  return trimTrailingSlash(configured);
};

const isLocalHostname = (hostname: string) =>
  hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';

export const getApiBaseUrl = () => {
  const configuredApiUrl = getConfiguredApiUrl();
  if (configuredApiUrl) {
    return configuredApiUrl;
  }

  if (typeof window !== 'undefined') {
    if (isLocalHostname(window.location.hostname)) {
      return 'http://localhost:5000/api';
    }

    return `${trimTrailingSlash(window.location.origin)}/api`;
  }

  return PRODUCTION_API_URL;
};

export const API_BASE_URL = getApiBaseUrl();

export const buildApiUrl = (path: string) => `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
